import PropTypes from 'prop-types';
import { Button, ModalComponent } from '../../../common/components';

const ConfirmPopup = ({ isOpen, toggle, onConfirm, message, confirmBtnText, cancelBtnText }) => {
  return (
    <ModalComponent isOpen={isOpen} toggle={toggle} className="acc-success-modal-1 lg">
      <div className="acconut-number-modal">
        <div className="save-change-h">Save Changes</div>
        <div className="acconut-number-modal-div my-3">
          <div className="acc-number-created-1">{message}</div>
          <Button color="primary" className="atd-btn acc-btn mr-4 my-3" onClick={onConfirm}>
            {confirmBtnText}
          </Button>
          <Button className="atd-btn acc-btn my-3 mr-3" color="default" onClick={toggle}>
            {cancelBtnText}
          </Button>
        </div>
      </div>
    </ModalComponent>
  );
};

ConfirmPopup.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
  confirmBtnText: PropTypes.string.isRequired,
  cancelBtnText: PropTypes.string.isRequired,
};

export default ConfirmPopup;
